import axios from "axios";

const API_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:3100";

const auth = (token) => ({ headers: { Authorization: `Bearer ${token}` } });

export async function userApproveOrder(token, orderId, attachment) {
  const body = attachment ? new FormData() : {};
  if (attachment) body.append("attachment", attachment);
  const res = await axios.put(
    `${API_URL}/api/orders/${orderId}/user-approve`,
    body,
    auth(token),
  );
  return res.data;
}

export async function userRejectOrder(token, orderId, reason) {
  const res = await axios.put(
    `${API_URL}/api/orders/${orderId}/reject`,
    { reason },
    auth(token),
  );
  return res.data;
}

export async function adminApproveOrder(token, orderId, attachment) {
  const body = attachment ? new FormData() : {};
  if (attachment) body.append("attachment", attachment);
  const res = await axios.post(
    `${API_URL}/api/approvals/order/${orderId}/approve`,
    body,
    auth(token),
  );
  return res.data;
}

export async function adminRejectOrder(token, orderId, reason) {
  const res = await axios.post(
    `${API_URL}/api/approvals/order/${orderId}/reject`,
    { reason },
    auth(token),
  );
  return res.data;
}

export async function makeSaleFromOrder(token, orderId) {
  const res = await axios.post(
    `${API_URL}/api/orders/${orderId}/make-sale`,
    {},
    auth(token),
  );
  return res.data;
}

export function extractSaleIdFromApproveResponse(data) {
  if (!data) return null;
  const saleId = data.saleId;
  if (typeof saleId === "string") return saleId;
  if (saleId?._id) return String(saleId._id);
  const fromOrder = data.order?.saleId;
  if (typeof fromOrder === "string") return fromOrder;
  if (fromOrder?._id) return String(fromOrder._id);
  return null;
}
